function TravelOptions({ travel, name = 'travel', onChange }) {
  return (
    <div className="content">
      <h2 className="josefin-slab upper">Travel</h2>

      <p className="josefin-slab">
        For guests staying at Briar Court the night before, we will provide a shuttle bus
        from Briar Court to Halifax Minster for the ceremony, and then on to The Manor House
        for the reception. We will also provide a shuttle from Halifax Minster to The Manor
        House for guests travelling independently to the ceremony.
      </p>

      <div className="rsvp-options">
        <label className="josefin-slab rsvp-label">
          <input type="radio" name={name} value="briar-court-shuttle" onChange={() => onChange('briar-court-shuttle')} checked={travel === 'briar-court-shuttle'} />
          I am staying at Briar Court and would like to use the shuttle bus
        </label>
        <label className="josefin-slab rsvp-label">
          <input type="radio" name={name} value="minster-shuttle" onChange={() => onChange('minster-shuttle')} checked={travel === 'minster-shuttle'} />
          I will make my own way to the Minster and would like to use the shuttle to the Manor House
        </label>
        <label className="josefin-slab rsvp-label">
          <input type="radio" name={name} value="own-transport" onChange={() => onChange('own-transport')} checked={travel === 'own-transport'} />
          I will make my own way there
        </label>
      </div>
    </div>
  );
}

export default TravelOptions;
